/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Presets_AriaInputs */



/**
* | output |
* | --- |
* | "Select export presets" |
*
* @param {Batch_Subtitle_Export_Presets_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_presets_aria = /** @type {((inputs?: Batch_Subtitle_Export_Presets_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Presets_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner les préréglages d’export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportvoreinstellungen auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i preset di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите параметры экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar ajustes preestablecidos de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择导出预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートプリセットを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात प्रीसेट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione as predefinições de exportação")
	return /** @type {LocalizedString} */ ("Select export presets")
});